import styled from 'styled-components';

export const ModalContentWrapper = styled.div`
  padding: 1.5rem;
  padding-bottom: 0;
`;